var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGstinImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3107 1H10.6893C8.25367 1 7.03584 1 6.03946 1.55252C5.04307 2.10503 4.45164 3.10831 3.26878 5.11486L2.67928 6.11486C1.55976 8.01395 1 8.9635 1 10C1 11.0365 1.55976 11.9861 2.67928 13.8851L3.26878 14.8851C4.45164 16.8917 5.04307 17.895 6.03946 18.4475C7.03584 19 8.25367 19 10.6893 19H11.3107C13.7463 19 14.9642 19 15.9605 18.4475C16.9569 17.895 17.5484 16.8917 18.7312 14.8851L19.3207 13.8851C20.4402 11.9861 21 11.0365 21 10C21 8.9635 20.4402 8.01395 19.3207 6.11485L18.7312 5.11486C17.5484 3.10831 16.9569 2.10503 15.9605 1.55252C14.9642 1 13.7463 1 11.3107 1Z",
    stroke: "#515151",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.992 14H11.001",
    stroke: "#515151",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9922 11L10.9922 6",
    stroke: "#515151",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGstinImage);
export default __webpack_public_path__ + "static/media/GstinImage.7b2785a42fa246599164b8d027c8b1b1.svg";
export { ForwardRef as ReactComponent };